import {Component, OnInit} from '@angular/core';
import {FirebaseService} from '../../../../../../service/firebase/firebase.service';
import {Pollenflug} from '../../../../../../model/vorhersagen/pollenflug';
import {BundeslandFilterService} from '../../../../../../service/bundeslandFilter/bundesland-filter.service';
import {BundesLandName} from '../../../../../../model/component/bundesland';

@Component({
  selector: 'app-pollenflug',
  templateUrl: './pollenflug.component.html',
  styleUrls: ['./pollenflug.component.css']
})
export class PollenflugComponent implements OnInit {

  public bundeslaenderTabs: string[] = [];

  private pollenflugList: Pollenflug[] = [];

  constructor(private firebaseService: FirebaseService,
              private bundeslandFilterService: BundeslandFilterService) {
  }

  ngOnInit() {
    this.firebaseService.getPollenflug().subscribe(pollenflugList => this.pollenflugList = pollenflugList);
    this.bundeslandFilterService.onFilterUpdated.subscribe(bundeslaender => {
      this.updateBundeslaenderTabs(bundeslaender);
    });
    this.updateBundeslaenderTabs(this.bundeslandFilterService.getSelectedBundesLaender());
  }

  getPollenflugForBundesland(bundeslandName: string): Pollenflug {
    return this.pollenflugList.find(pollenflug => this.belongsToBundesland(pollenflug, bundeslandName));
  }

  private updateBundeslaenderTabs(bundeslaender) {
    if (this.bundeslandFilterService.hasDeutschlandFilterActive()) {
      this.bundeslaenderTabs = Object.values(BundesLandName);
    } else {
      this.bundeslaenderTabs = bundeslaender.map(bundesland => bundesland.name);
    }
  }

  private belongsToBundesland(pollenflug: Pollenflug, bundeslandName: string): boolean {
    return pollenflug.ort.bundesLand === (bundeslandName === BundesLandName.HB ? 'Bremen' : bundeslandName);
  }

}
